<template>
    <div class="property-type-selector">

        <div class="row button-row">
            <div class="col"><h4>Select the type of property you would like to sell</h4> </div>
        </div>
        <div class="row button-row">
            <div class="col">   <b-button class="button" :pressed="isSelected('SINGLE_FAMILY')" pill variant="outline-secondary" @click="updatePropertyType('SINGLE_FAMILY')">
                <b-icon icon="house-door" aria-hidden="true"></b-icon>
                Single Family</b-button></div>
        </div>
        <div class="row button-row">
            <div class="col">   <b-button class="button" :pressed="isSelected('MULTI_FAMILY')" pill variant="outline-secondary" @click="updatePropertyType('MULTI_FAMILY')">
                <b-icon icon="house" aria-hidden="true"></b-icon>
                Multi Family</b-button></div>
        </div>
        <div class="row button-row">
            <div class="col"> <b-button class="button" :pressed="isSelected('CONDOMINIUM')" pill variant="outline-secondary" @click="updatePropertyType('CONDOMINIUM')">
                <b-icon icon="building" aria-hidden="true"></b-icon>
                Condominium</b-button> </div>
        </div>
        <div class="row button-row">
            <div class="col">   <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('TOWNHOUSE')" @click="updatePropertyType('TOWNHOUSE')">
                <b-icon icon="house" aria-hidden="true"></b-icon>
                Townhouse</b-button> </div>
        </div>
        <div class="row button-row">
            <div class="col"> <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('MOBILE_HOME')" @click="updatePropertyType('MOBILE_HOME')">
                <span style="font-size: 75%"><b-icon icon="house-door" aria-hidden="true"></b-icon></span>
                Mobile Home</b-button> </div>
        </div>
        <div class="row button-row">
            <div class="col"> <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('COMMERCIAL')" @click="updatePropertyType('COMMERCIAL')">
                <b-icon icon="graph-up" aria-hidden="true"></b-icon>
                Commercial</b-button> </div>
        </div>
        <div class="row button-row">
            <div class="col"> <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('VACANT_LOT')" @click="updatePropertyType('VACANT_LOT')">
                <b-icon icon="dash" aria-hidden="true"></b-icon>
                Vacant Lot</b-button> </div>
        </div>
    </div>
</template>

<script>
    import {saveField} from "@/services/apiService";

    export default {
        name: "PropertyType",
        props: ['value'],
        model: {
            prop: 'value',
            event: 'selected'
        },
        data (){
            return {
                propertyType: null
            }
        },
        methods: {
            updatePropertyType: function (value){
                this.propertyType = value;
                this.$emit('selected', value);
                saveField('Property_Type', this.propertyType);
            },
            isSelected: function (value){
                return this.value === value;
            }
        },
        computed:{

        }

    }
</script>

<style scoped>
    .button-row{
        padding: 5px;
    }
.button{
    margin: auto;
    left: 0;
    right: 0;
    padding: 10px;
    width: 175px;
}

</style>
